<template>
  <div>
    <div class="px-4 py-4 wizard_app_modal">
      <div v-if="selectedApplication === null && applicationToEdit === null">
        <list-applications
          :user="$page.props.user"
          :other-application="otherApplication"
          :is-from-wizard="true"
          :title="`${trans('common.application')} ${appId}`"
          @application-selected="handleApplicationSelected"
          @your-application-selected="handleYourApplicationSelected"
        />
      </div>
      <div v-else>
        <div class="wizard_wrap">
          <div>
            <h4 class="px-6 mb-4 justify-center">
              <img :src="getApplicationLogo(application)" width="100px" height="100px" alt="Application Logo"/>
              {{ application.name }}
            </h4>
          </div>
          <div class="grid-3 wizard_grid">
            <div style="grid-column: span 2 / span 2">
              <application-form
                :key="applicationId"
                :user="$page.props.user"
                :application-id="applicationId"
                :is-from-wizard="true"
                :is-new="selectedApplication !== null"
                @successful-test-connection="handleSuccessfulTestConnection"
                @go-back="goBack"
              />
            </div>
            <div class="text-center">
              <div v-if="! videoLink" class="wizard_bg wizard_bg_app" style="z-index: 10"></div>
              <div v-else class="mr-md-3">
                <div class="video_wrap">
                  <div style="padding: 56.25% 0 0 0; position: relative">
                    <iframe
                      :src="videoLink"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowfullscreen
                      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
              <div v-if="application.about_api_details" class="mt-4 text-left">
                <p>{{ application.about_api_details }}</p>
              </div>
              <a
                style="z-index: 20"
                v-if="application.manual_link"
                class="button position-relative d-sm-none d-md-inline-block"
                :class="{ 'my-4': !!videoLink }"
                :href="application.manual_link"
                target="_blank"
              >
                {{ trans('dashboard.integrations.wizard.second_step.manual_description') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListApplications from '@/components/Dashboard/ListApplications';
import ApplicationForm from '@/components/Dashboard/Application/Form';

export default {
  name: 'WizardApplications',

  components: {
    ApplicationForm,
    ListApplications,
  },

  props: {
    isSaveButtonEnabled: {
      type: Boolean,
      default: true,
    },

    appId: {
      type: [String, Number],
      default: null,
    },

    applicationToEdit: {
      type: Object,
      default: null,
    },

    application1: {
      type: Object,
      default: null,
    },

    application2: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      selectedApplication: null,
      isScrollable: false,
    };
  },

  computed: {
    videoLink() {
      return this.selectedApplication?.auth_video_link ?? null;
    },

    otherApplication() {
      return this.appId === 1 ? this.application2 : this.application1;
    },

    applicationId() {
      const application = this.applicationToEdit !== null ? this.applicationToEdit : this.selectedApplication;

      return application.id;
    },

    application() {
      return this.selectedApplication || this.applicationToEdit.application;
    },
  },

  /**
   * Mount the component.
   */
  mounted() {
    this.isScrollable = true;
  },

  methods: {
    handleClose() {
      this.selectedApplication = null;
      this.$emit('close');
    },

    handleApplicationSelected(application) {
      this.application = application;
      this.selectedApplication = application;
    },

    handleSuccessfulTestConnection(application) {
      this.emitApplicationSelected(application);
    },

    handleYourApplicationSelected(application) {
      this.emitApplicationSelected(application);
    },

    emitApplicationSelected(application) {
      this.$emit('application-selected', application);
    },

    goBack() {
      this.selectedApplication = null;
    },

    getApplicationLogo(application) {
      const logoFallback = `https://avatars.dicebear.com/api/identicon/${application.name}.svg`;
      const logo = application.logo_url;
      return logo ? logo : logoFallback;
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  margin-top: 10px;
  border-color: #3c4b5f;
  border-width: 1px;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 12%), 0 2px 4px 0 rgb(0 0 0 / 8%);
  width: 120px;
  height: 120px;
}

.button {
  &_offset {
    transform: translate(-1rem, 17rem);
  }
}

.wizard {
  &_app {
    &_modal {
      background-color: var(--bg-haze);
    }
  }

  &_wrap {
    min-height: 500px;
  }
}
</style>
